import { render, staticRenderFns } from "./loginInfo.vue?vue&type=template&id=0b1ef2fc&scoped=true"
import script from "./loginInfo.vue?vue&type=script&lang=js"
export * from "./loginInfo.vue?vue&type=script&lang=js"
import style0 from "./loginInfo.vue?vue&type=style&index=0&id=0b1ef2fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ef2fc",
  null
  
)

export default component.exports